// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"templatePropertyStyles_headerActions__2pMCI","clickableRow":"templatePropertyStyles_clickableRow__22wQo"};